import roles, { ROLES } from '~/shared/const/roles'

type RoleId = (typeof ROLES)[keyof typeof ROLES]

// Часть пользователя, нужная для проверки маршрутов: shared не зависит от models
export interface RoutableUser {
  roles: Set<RoleId>
  allowedRoutes: Array<RegExp>
}

// Чем выше в списке, тем важнее роль при выборе стартовой страницы ЛК
export const ROLE_PRIORITY: ReadonlyArray<RoleId> = [
  ROLES.VACANCY_ADMIN,
  ROLES.COMPANY,
  ROLES.VACANCY_MANAGER,
  ROLES.DIGITAL_PROFILES,
  ROLES.REPORTS_MANAGER,
  ROLES.TUTOR,
  ROLES.UNIVERSITY,
  ROLES.FIZ,
]

// Основная роль с учётом приоритета
export function getPrimaryRole(user: RoutableUser | null): RoleId | null {
  if (!user || user.roles.size === 0) {
    return null
  }

  return ROLE_PRIORITY.find(role => user.roles.has(role)) ?? ([...user.roles][0] as RoleId)
}

// Стартовая страница ЛК
export function getDefaultAccountRoute(user: RoutableUser | null): string {
  const primaryRole = getPrimaryRole(user)

  return (primaryRole && roles[primaryRole]?.defaultRoute) || '/'
}

// Доступен ли пользователю путь внутри ЛК
export function hasRouteAccess(user: RoutableUser | null, path: string): boolean {
  // регулярки в roles.ts описаны без хвостового слеша
  const normalizedPath = path.length > 1 ? path.replace(/\/+$/, '') : path

  return !!user && user.allowedRoutes.some((rgx: RegExp) => rgx.test(normalizedPath))
}
